<template>
  <section class="section upskill_faq">
    <div class="container">
      <div class="sign_up_faq">
        <div class="faq_item" v-for="(item, index) in items" :key="index">
          <h3 class="faq_item__text">
            {{ item.q }}
          </h3>
          <p class="faq_item__desc">
            {{ item.a }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["items"]
};
</script>
